var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavLinkBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_67293)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73755 2.56053C9.905 2.48239 10.0984 2.48246 10.2659 2.56053L19.6409 6.93553C19.8667 7.04091 20.0092 7.27043 20.0022 7.51952C19.995 7.7683 19.8407 7.98945 19.6096 8.08202L18.7522 8.42479V16.2519C19.4425 16.252 20.0022 16.8116 20.0022 17.5019V20.0019H16.2522V17.5019C16.2522 16.8116 16.8118 16.2519 17.5022 16.2519V8.92479L10.2346 11.832C10.0856 11.8916 9.91879 11.8916 9.76978 11.832L0.394778 8.08202C0.163596 7.98952 0.0093734 7.76839 0.00220027 7.51952C-0.00478782 7.27054 0.136926 7.04097 0.362552 6.93553L9.73755 2.56053ZM14.7825 11.291C14.9451 11.23 15.1261 11.2398 15.2815 11.3174C15.4367 11.3949 15.5528 11.5337 15.6018 11.7002L16.2268 13.8252C16.3177 14.1343 16.1587 14.4622 15.8596 14.582L10.2346 16.832C10.0856 16.8916 9.91879 16.8916 9.76978 16.832L4.14478 14.582C3.84553 14.4623 3.68664 14.1344 3.77759 13.8252L4.40259 11.7002C4.45159 11.5336 4.56755 11.3949 4.7229 11.3174C4.87827 11.2398 5.05933 11.23 5.22193 11.291L10.0022 13.084L14.7825 11.291Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_775_67293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLinkBase);
export default __webpack_public_path__ + "static/media/nav-link-base.4b62d64481b12605e64748b2ef9edb4f.svg";
export { ForwardRef as ReactComponent };